import { render } from "./container-details-dispatch.vue?vue&type=template&id=f77f2b32&scoped=true"
import script from "./container-details-dispatch.vue?vue&type=script&lang=js"
export * from "./container-details-dispatch.vue?vue&type=script&lang=js"

import "./container-details-dispatch.vue?vue&type=style&index=0&id=f77f2b32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77f2b32"]])

export default __exports__